module.exports = __webpack_public_path__ + "static/media/3.2ae7f164.png";